import apiSlice from "../apiSlice";
import type { HomeResponseType } from "src/types/products/ProductResponses";


const coreApiSlice = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        home: build.query<HomeResponseType, void>({
            query: () => (`/core/`),
            providesTags: (result) => result ? [
                ...result.latest.map((product) => ({ type: "Product" as const, id: product.id })),
                ...result.offers.map((product) => ({ type: "Product" as const, id: product.id })),
                ...result.best.map((product) => ({ type: "Product" as const, id: product.id })),
                { type: "Product" as const, id: "HOME" },
            ] : [{ type: "Product" as const, id: "HOME" }],
        })
    })
})


export const { useHomeQuery } = coreApiSlice;
